<script>

import MerchantPromotion from '@/views/AadenPages/memberShipReborn/MarketingCampaign/MerchantPromotion.vue'

// 「邮件管理」「新发邮件」两个 tab 已隐藏：云端营销群发接口 /api/marketing/campaigns 已下线
// （匿名可调、群发没有单独的营销同意和退订链接，见 cloud#263）。页面文件先保留，以后补好同意和退订再恢复。
export default {
  name: 'MarketingIndex',
  components: {
    MerchantPromotion
  },
  data () {
    return {
      tab: null
    }
  }
}
</script>

<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="black"
      style="background: transparent"
    >
      <v-tab>商家推广</v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <merchant-promotion />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style scoped>

</style>
